// extracted by css-extract-rspack-plugin
export default {"pendingComponentRoot":"pendingComponentRoot-Iw6wPi","pendingComponentContent":"pendingComponentContent-c8gmHM"};